import Repository from './Repository'

export default {
  getTopics(queries: any) {
    return Repository.get('topic', { params: queries })
  },
  getTopic(topic_id: number) {
    return Repository.get(`topic/${topic_id}`)
  },
  postTopic(data: any) {
    return Repository.post('topic', data)
  },
  updateTopic(data: any) {
    return Repository.put('topic', data)
  },
  deleteTopic(params: any) {
    return Repository.delete('topic', { data: params })
  }
}